(function () {
  function ensureVideoAutoplay(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    if (!video.muted && (video.autoplay || video.getAttribute('autoplay') !== null)) {
      video.muted = true;
    }
    if (video.preload !== 'auto') video.setAttribute('preload', 'auto');
  }

  function processVideos() {
    document.querySelectorAll('video').forEach(ensureVideoAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processVideos);
  } else {
    processVideos();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.tagName === 'VIDEO') ensureVideoAutoplay(node);
          if (node.querySelectorAll) node.querySelectorAll('video').forEach(ensureVideoAutoplay);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
